import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=145fc472&scoped=true"
import script from "./menuItem.vue?vue&type=script&lang=js"
export * from "./menuItem.vue?vue&type=script&lang=js"
import style0 from "./menuItem.vue?vue&type=style&index=0&id=145fc472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145fc472",
  null
  
)

export default component.exports